import messages from '@karrotmarket/gatsby-theme-website-team/src/translation/messages.json';

export function useTranslation(): Record<string, string> {
  return messages;
}
